import ImaScriptLoader from 'app/components/tv/handler/ImaScriptLoader';
import VideoAds, {SetAdPlaying, SetRemainingTime} from 'app/components/tv/handler/VideoAds';
import Video from 'app/components/tv/models/video';
import VideoAdsException from 'app/exceptions/VideoAdsException';
import {checkPlayAd} from 'app/helpers/adStepper';
import {captureSentryException} from 'app/services/sentryLogging';
import {VideoJsPlayer} from 'video.js';

export default class VideoAdController {
  private static instance: VideoAdController;
  preventAds: boolean;
  private readonly getVideoAds: (player: VideoJsPlayer) => VideoAds;
  private videoAds: VideoAds | null;
  private readonly imaScriptLoader: ImaScriptLoader;

  private constructor(adsDisabled: boolean, getVideoAds: (player: VideoJsPlayer) => VideoAds) {
    this.preventAds = adsDisabled;
    this.getVideoAds = getVideoAds;
    this.imaScriptLoader = new ImaScriptLoader();
  }

  static getInstance(adsDisabled?: boolean, getVideoAds?: (player: VideoJsPlayer) => VideoAds): VideoAdController {
    if (!VideoAdController.instance) {
      if (adsDisabled === undefined || getVideoAds === undefined) {
        throw new VideoAdsException(
          'Parameters adsDisabled and newVideoAds are required to create a VideoAdController'
        );
      }
      VideoAdController.instance = new VideoAdController(adsDisabled, getVideoAds);
    }
    return VideoAdController.instance;
  }

  async loadImaScript(): Promise<void> {
    if (this.preventAds) {
      return;
    }
    try {
      await this.imaScriptLoader.load();
    } catch (e) {
      // There was an error loading the IMA-script
      // -> should probably log this, but it's not in our hand if it succeeds
      this.preventAds = true;
    }
  }

  setupAds(
    player: VideoJsPlayer,
    setAdPlaying: SetAdPlaying,
    setRemainingTime: SetRemainingTime,
    isFirstPage: boolean,
    ppid: string
  ): void {
    if (this.preventAds) {
      return;
    }
    try {
      this.videoAds = this.getVideoAds(player);
      this.videoAds.setup(setAdPlaying, setRemainingTime, isFirstPage, ppid);
    } catch (e) {
      captureSentryException(e);
      this.preventAds = true;
    }
  }

  requestAds(followUpVideo: Video): void {
    if (this.preventAds || !this.videoAds) {
      throw new VideoAdsException('Ads not initialized');
    }
    if (!this.shouldPlayAd()) {
      throw new VideoAdsException("Don't play ad: Still credits available");
    }
    this.videoAds.requestAds(followUpVideo);
  }

  private shouldPlayAd(): boolean {
    return checkPlayAd();
  }

  dispose(): void {
    this.imaScriptLoader.unload();
    if (this.videoAds) {
      this.videoAds.dispose();
    }
    this.videoAds = null;
  }
}
